export default {
  namespaced: true,
  state: {
    items: [],
  },
  actions: {
    GetList({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'types', value: [] });
      rootGetters.axl.post('profiles/api/jobs/portfolio', payload)
        .then((response) => {
          commit('setField', { name: 'items', value: response.data.items });
        })
        .catch((error) => {
          dispatch('HandleError', error, { root: true });
        });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
